<template>
  <div class="title">
    <img :src="imagePath" :alt="imageAlt" class="title_block-icon">
    <span class="title_text">{{title}}</span>
  </div>
</template>

<script>
  export default {
    name: 'TitleBlock',
    props: ['imagePath', 'imageAlt', 'title']
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/manager/TitleBlock.vue